<template>
  <sb-modal
    :active="showModal"
    :escapeTrigger="false"
    class="cost-calculator-modal"
    :clickOutsideTrigger="false"
    :class="$mq"
    @close="onClose"
  >
    <header class="modal-header">
      <slot name="header">
        <p class="header-title">
          {{$t("HeaderTitle")}}
        </p>
        <p class="header-subtitle">
          {{$t("HeaderSubTitle")}}
        </p>
      </slot>
    </header>
    <section class="modal-body">
      <slot name="body">
          <CostCalculator />
      </slot>
    </section>
    <footer class="modal-footer">
      <slot name="footer">
        <div class="cost-calculator-footer-container">
          <sb-button
            variation="link"
            @click="onClose"
          >
            {{$t("ButtonClose")}}
          </sb-button>
        </div>
      </slot>
    </footer>
  </sb-modal>
</template>

<script>
import CostCalculator from '../../onboarding/questions/CostCalculator.vue'

export default {
  name: 'CostCalculatorModal',
  components: {
    CostCalculator
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => null
    }
  },
  i18n: {
    messages: {
      'en-US': {
        HeaderTitle: 'Price Calculator',
        HeaderSubTitle: 'Use the calculator below to estimate what it would cost to ship a product to your customer.',
        ButtonClose: 'Close'
      }
    }
  }
}
</script>


<style lang='scss'>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_setup-panel-cost-calculator-modal.scss';
</style>